import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "files, documents" }, [
      _createElementVNode("path", {
        id: "vector",
        d: "M14.3752 15.2082V16.0415C14.3752 16.962 13.629 17.7082 12.7085 17.7082H5.62516C4.70469 17.7082 3.9585 16.962 3.9585 16.0415V6.45817C3.9585 5.5377 4.70469 4.7915 5.62516 4.7915H6.4585M12.7085 2.2915H8.12516C7.20469 2.2915 6.4585 3.0377 6.4585 3.95817V13.5415C6.4585 14.462 7.20469 15.2082 8.12516 15.2082H15.2085C16.129 15.2082 16.8752 14.462 16.8752 13.5415V6.45817M12.7085 2.2915L16.8752 6.45817M12.7085 2.2915V4.7915C12.7085 5.71198 13.4547 6.45817 14.3752 6.45817H16.8752",
        stroke: "currentColor",
        "stroke-width": "1.5",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      })
    ], -1)
  ])))
}
export default { render: render }